"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1493],{

/***/ 27190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": function() { return /* binding */ Accordion; },
  "KF": function() { return /* binding */ AccordionButton; },
  "XE": function() { return /* binding */ AccordionIcon; },
  "Qd": function() { return /* binding */ AccordionItem; },
  "Hk": function() { return /* binding */ AccordionPanel; }
});

// UNUSED EXPORTS: AccordionProvider, useAccordion, useAccordionContext, useAccordionItem, useAccordionItemState, useAccordionStyles

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js
var index_esm = __webpack_require__(83904);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-context/dist/index.esm.js
var dist_index_esm = __webpack_require__(28387);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-merge-refs/dist/index.esm.js
var react_use_merge_refs_dist_index_esm = __webpack_require__(76734);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/descendant/dist/index.esm.js
// src/use-descendant.ts




// src/utils.ts

function sortNodes(nodes) {
  return nodes.sort((a, b) => {
    const compare = a.compareDocumentPosition(b);
    if (compare & Node.DOCUMENT_POSITION_FOLLOWING || compare & Node.DOCUMENT_POSITION_CONTAINED_BY) {
      return -1;
    }
    if (compare & Node.DOCUMENT_POSITION_PRECEDING || compare & Node.DOCUMENT_POSITION_CONTAINS) {
      return 1;
    }
    if (compare & Node.DOCUMENT_POSITION_DISCONNECTED || compare & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC) {
      throw Error("Cannot sort the given nodes.");
    } else {
      return 0;
    }
  });
}
var isElement = (el) => typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
function getNextIndex(current, max, loop) {
  let next = current + 1;
  if (loop && next >= max)
    next = 0;
  return next;
}
function getPrevIndex(current, max, loop) {
  let next = current - 1;
  if (loop && next < 0)
    next = max;
  return next;
}
var useSafeLayoutEffect = typeof window !== "undefined" ? react.useLayoutEffect : react.useEffect;
var cast = (value) => value;

// src/descendant.ts
var DescendantsManager = class {
  descendants = /* @__PURE__ */ new Map();
  register = (nodeOrOptions) => {
    if (nodeOrOptions == null)
      return;
    if (isElement(nodeOrOptions)) {
      return this.registerNode(nodeOrOptions);
    }
    return (node) => {
      this.registerNode(node, nodeOrOptions);
    };
  };
  unregister = (node) => {
    this.descendants.delete(node);
    const sorted = sortNodes(Array.from(this.descendants.keys()));
    this.assignIndex(sorted);
  };
  destroy = () => {
    this.descendants.clear();
  };
  assignIndex = (descendants) => {
    this.descendants.forEach((descendant) => {
      const index = descendants.indexOf(descendant.node);
      descendant.index = index;
      descendant.node.dataset["index"] = descendant.index.toString();
    });
  };
  count = () => this.descendants.size;
  enabledCount = () => this.enabledValues().length;
  values = () => {
    const values = Array.from(this.descendants.values());
    return values.sort((a, b) => a.index - b.index);
  };
  enabledValues = () => {
    return this.values().filter((descendant) => !descendant.disabled);
  };
  item = (index) => {
    if (this.count() === 0)
      return void 0;
    return this.values()[index];
  };
  enabledItem = (index) => {
    if (this.enabledCount() === 0)
      return void 0;
    return this.enabledValues()[index];
  };
  first = () => this.item(0);
  firstEnabled = () => this.enabledItem(0);
  last = () => this.item(this.descendants.size - 1);
  lastEnabled = () => {
    const lastIndex = this.enabledValues().length - 1;
    return this.enabledItem(lastIndex);
  };
  indexOf = (node) => {
    var _a;
    if (!node)
      return -1;
    return ((_a = this.descendants.get(node)) == null ? void 0 : _a.index) ?? -1;
  };
  enabledIndexOf = (node) => {
    if (node == null)
      return -1;
    return this.enabledValues().findIndex((i) => i.node.isSameNode(node));
  };
  next = (index, loop = true) => {
    const next = getNextIndex(index, this.count(), loop);
    return this.item(next);
  };
  nextEnabled = (index, loop = true) => {
    const item = this.item(index);
    if (!item)
      return;
    const enabledIndex = this.enabledIndexOf(item.node);
    const nextEnabledIndex = getNextIndex(enabledIndex, this.enabledCount(), loop);
    return this.enabledItem(nextEnabledIndex);
  };
  prev = (index, loop = true) => {
    const prev = getPrevIndex(index, this.count() - 1, loop);
    return this.item(prev);
  };
  prevEnabled = (index, loop = true) => {
    const item = this.item(index);
    if (!item)
      return;
    const enabledIndex = this.enabledIndexOf(item.node);
    const prevEnabledIndex = getPrevIndex(enabledIndex, this.enabledCount() - 1, loop);
    return this.enabledItem(prevEnabledIndex);
  };
  registerNode = (node, options) => {
    if (!node || this.descendants.has(node))
      return;
    const keys = Array.from(this.descendants.keys()).concat(node);
    const sorted = sortNodes(keys);
    if (options == null ? void 0 : options.disabled) {
      options.disabled = !!options.disabled;
    }
    const descendant = { node, index: -1, ...options };
    this.descendants.set(node, descendant);
    this.assignIndex(sorted);
  };
};

// src/use-descendant.ts
function useDescendants() {
  const descendants = (0,react.useRef)(new DescendantsManager());
  useSafeLayoutEffect(() => {
    return () => descendants.current.destroy();
  });
  return descendants.current;
}
var [DescendantsContextProvider, useDescendantsContext] = (0,dist_index_esm/* createContext */.k)({
  name: "DescendantsProvider",
  errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function useDescendant(options) {
  const descendants = useDescendantsContext();
  const [index, setIndex] = (0,react.useState)(-1);
  const ref = (0,react.useRef)(null);
  useSafeLayoutEffect(() => {
    return () => {
      if (!ref.current)
        return;
      descendants.unregister(ref.current);
    };
  }, []);
  useSafeLayoutEffect(() => {
    if (!ref.current)
      return;
    const dataIndex = Number(ref.current.dataset["index"]);
    if (index != dataIndex && !Number.isNaN(dataIndex)) {
      setIndex(dataIndex);
    }
  });
  const refCallback = options ? cast(descendants.register(options)) : cast(descendants.register);
  return {
    descendants,
    index,
    enabledIndex: descendants.enabledIndexOf(ref.current),
    register: (0,react_use_merge_refs_dist_index_esm/* mergeRefs */.lq)(refCallback, ref)
  };
}
function createDescendantContext() {
  const ContextProvider = cast(DescendantsContextProvider);
  const _useDescendantsContext = () => cast(useDescendantsContext());
  const _useDescendant = (options) => useDescendant(options);
  const _useDescendants = () => useDescendants();
  return [
    ContextProvider,
    _useDescendantsContext,
    _useDescendants,
    _useDescendant
  ];
}


// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-use-controllable-state/dist/index.esm.js
var react_use_controllable_state_dist_index_esm = __webpack_require__(98053);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/index.esm.js
var transition_dist_index_esm = __webpack_require__(71197);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.esm.js
var styled_system_dist_index_esm = __webpack_require__(54520);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js
// ../../../react-shim.js


// src/accordion-button.tsx


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}

// src/accordion-context.ts


var [AccordionStylesProvider, useAccordionStyles] = (0,dist_index_esm/* createContext */.k)({
  name: "AccordionStylesContext",
  hookName: "useAccordionStyles",
  providerName: "<Accordion />"
});
var [AccordionItemProvider, useAccordionItemContext] = (0,dist_index_esm/* createContext */.k)({
  name: "AccordionItemContext",
  hookName: "useAccordionItemContext",
  providerName: "<AccordionItem />"
});
var [
  AccordionDescendantsProvider,
  useAccordionDescendantsContext,
  useAccordionDescendants,
  useAccordionDescendant
] = createDescendantContext();

// src/accordion-button.tsx
var AccordionButton = (0,index_esm/* forwardRef */.Gp)(function AccordionButton2(props, ref) {
  const { getButtonProps } = useAccordionItemContext();
  const buttonProps = getButtonProps(props, ref);
  const styles = useAccordionStyles();
  const buttonStyles = {
    display: "flex",
    alignItems: "center",
    width: "100%",
    outline: 0,
    ...styles.button
  };
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.button */.m$.button, {
    ...buttonProps,
    className: cx("chakra-accordion__button", props.className),
    __css: buttonStyles
  });
});
AccordionButton.displayName = "AccordionButton";

// src/accordion-icon.tsx


// src/use-accordion.ts




function useAccordion(props) {
  const {
    onChange,
    defaultIndex,
    index: indexProp,
    allowMultiple,
    allowToggle,
    ...htmlProps
  } = props;
  allowMultipleWarning(props);
  allowMultipleAndAllowToggleWarning(props);
  const descendants = useAccordionDescendants();
  const [focusedIndex, setFocusedIndex] = (0,react.useState)(-1);
  (0,react.useEffect)(() => {
    return () => {
      setFocusedIndex(-1);
    };
  }, []);
  const [index, setIndex] = (0,react_use_controllable_state_dist_index_esm/* useControllableState */.T)({
    value: indexProp,
    defaultValue() {
      if (allowMultiple)
        return defaultIndex ?? [];
      return defaultIndex ?? -1;
    },
    onChange
  });
  const getAccordionItemProps = (idx) => {
    let isOpen = false;
    if (idx !== null) {
      isOpen = Array.isArray(index) ? index.includes(idx) : index === idx;
    }
    const onChange2 = (isOpen2) => {
      if (idx === null)
        return;
      if (allowMultiple && Array.isArray(index)) {
        const nextState = isOpen2 ? index.concat(idx) : index.filter((i) => i !== idx);
        setIndex(nextState);
      } else if (isOpen2) {
        setIndex(idx);
      } else if (allowToggle) {
        setIndex(-1);
      }
    };
    return { isOpen, onChange: onChange2 };
  };
  return {
    index,
    setIndex,
    htmlProps,
    getAccordionItemProps,
    focusedIndex,
    setFocusedIndex,
    descendants
  };
}
var [AccordionProvider, useAccordionContext] = (0,dist_index_esm/* createContext */.k)({
  name: "AccordionContext",
  hookName: "useAccordionContext",
  providerName: "Accordion"
});
function useAccordionItem(props) {
  const { isDisabled, isFocusable, id, ...htmlProps } = props;
  const { getAccordionItemProps, setFocusedIndex } = useAccordionContext();
  const buttonRef = (0,react.useRef)(null);
  const reactId = (0,react.useId)();
  const uid = id ?? reactId;
  const buttonId = `accordion-button-${uid}`;
  const panelId = `accordion-panel-${uid}`;
  focusableNotDisabledWarning(props);
  const { register, index, descendants } = useAccordionDescendant({
    disabled: isDisabled && !isFocusable
  });
  const { isOpen, onChange } = getAccordionItemProps(index === -1 ? null : index);
  warnIfOpenAndDisabled({ isOpen, isDisabled });
  const onOpen = () => {
    onChange == null ? void 0 : onChange(true);
  };
  const onClose = () => {
    onChange == null ? void 0 : onChange(false);
  };
  const onClick = (0,react.useCallback)(() => {
    onChange == null ? void 0 : onChange(!isOpen);
    setFocusedIndex(index);
  }, [index, setFocusedIndex, isOpen, onChange]);
  const onKeyDown = (0,react.useCallback)((event) => {
    const keyMap = {
      ArrowDown: () => {
        const next = descendants.nextEnabled(index);
        next == null ? void 0 : next.node.focus();
      },
      ArrowUp: () => {
        const prev = descendants.prevEnabled(index);
        prev == null ? void 0 : prev.node.focus();
      },
      Home: () => {
        const first = descendants.firstEnabled();
        first == null ? void 0 : first.node.focus();
      },
      End: () => {
        const last = descendants.lastEnabled();
        last == null ? void 0 : last.node.focus();
      }
    };
    const action = keyMap[event.key];
    if (action) {
      event.preventDefault();
      action(event);
    }
  }, [descendants, index]);
  const onFocus = (0,react.useCallback)(() => {
    setFocusedIndex(index);
  }, [setFocusedIndex, index]);
  const getButtonProps = (0,react.useCallback)(function getButtonProps2(props2 = {}, ref = null) {
    return {
      ...props2,
      type: "button",
      ref: (0,react_use_merge_refs_dist_index_esm/* mergeRefs */.lq)(register, buttonRef, ref),
      id: buttonId,
      disabled: !!isDisabled,
      "aria-expanded": !!isOpen,
      "aria-controls": panelId,
      onClick: callAllHandlers(props2.onClick, onClick),
      onFocus: callAllHandlers(props2.onFocus, onFocus),
      onKeyDown: callAllHandlers(props2.onKeyDown, onKeyDown)
    };
  }, [
    buttonId,
    isDisabled,
    isOpen,
    onClick,
    onFocus,
    onKeyDown,
    panelId,
    register
  ]);
  const getPanelProps = (0,react.useCallback)(function getPanelProps2(props2 = {}, ref = null) {
    return {
      ...props2,
      ref,
      role: "region",
      id: panelId,
      "aria-labelledby": buttonId,
      hidden: !isOpen
    };
  }, [buttonId, isOpen, panelId]);
  return {
    isOpen,
    isDisabled,
    isFocusable,
    onOpen,
    onClose,
    getButtonProps,
    getPanelProps,
    htmlProps
  };
}
function allowMultipleWarning(props) {
  const index = props.index || props.defaultIndex;
  const condition = index != null && !Array.isArray(index) && props.allowMultiple;
  warn({
    condition: !!condition,
    message: `If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof index},`
  });
}
function allowMultipleAndAllowToggleWarning(props) {
  warn({
    condition: !!(props.allowMultiple && props.allowToggle),
    message: `If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not`
  });
}
function focusableNotDisabledWarning(props) {
  warn({
    condition: !!(props.isFocusable && !props.isDisabled),
    message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
  });
}
function warnIfOpenAndDisabled(props) {
  warn({
    condition: props.isOpen && !!props.isDisabled,
    message: "Cannot open a disabled accordion item"
  });
}

// src/accordion-icon.tsx
function AccordionIcon(props) {
  const { isOpen, isDisabled } = useAccordionItemContext();
  const { reduceMotion } = useAccordionContext();
  const _className = cx("chakra-accordion__icon", props.className);
  const styles = useAccordionStyles();
  const iconStyles = {
    opacity: isDisabled ? 0.4 : 1,
    transform: isOpen ? "rotate(-180deg)" : void 0,
    transition: reduceMotion ? void 0 : "transform 0.2s",
    transformOrigin: "center",
    ...styles.icon
  };
  return /* @__PURE__ */ react.createElement(icon_dist_index_esm/* Icon */.JO, {
    viewBox: "0 0 24 24",
    "aria-hidden": true,
    className: _className,
    __css: iconStyles,
    ...props
  }, /* @__PURE__ */ react.createElement("path", {
    fill: "currentColor",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  }));
}
AccordionIcon.displayName = "AccordionIcon";

// src/accordion-item.tsx


var AccordionItem = (0,index_esm/* forwardRef */.Gp)(function AccordionItem2(props, ref) {
  const { children, className } = props;
  const { htmlProps, ...context } = useAccordionItem(props);
  const styles = useAccordionStyles();
  const containerStyles = {
    ...styles.container,
    overflowAnchor: "none"
  };
  const ctx = (0,react.useMemo)(() => context, [context]);
  return /* @__PURE__ */ react.createElement(AccordionItemProvider, {
    value: ctx
  }, /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ref,
    ...htmlProps,
    className: cx("chakra-accordion__item", className),
    __css: containerStyles
  }, typeof children === "function" ? children({
    isExpanded: !!context.isOpen,
    isDisabled: !!context.isDisabled
  }) : children));
});
AccordionItem.displayName = "AccordionItem";

// src/accordion-panel.tsx


var AccordionPanel = (0,index_esm/* forwardRef */.Gp)(function AccordionPanel2(props, ref) {
  const { className, motionProps, ...rest } = props;
  const { reduceMotion } = useAccordionContext();
  const { getPanelProps, isOpen } = useAccordionItemContext();
  const panelProps = getPanelProps(rest, ref);
  const _className = cx("chakra-accordion__panel", className);
  const styles = useAccordionStyles();
  if (!reduceMotion) {
    delete panelProps.hidden;
  }
  const child = /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ...panelProps,
    __css: styles.panel,
    className: _className
  });
  if (!reduceMotion) {
    return /* @__PURE__ */ react.createElement(transition_dist_index_esm/* Collapse */.UO, {
      in: isOpen,
      ...motionProps
    }, child);
  }
  return child;
});
AccordionPanel.displayName = "AccordionPanel";

// src/accordion.tsx


var Accordion = (0,index_esm/* forwardRef */.Gp)(function Accordion2({ children, reduceMotion, ...props }, ref) {
  const styles = (0,index_esm/* useMultiStyleConfig */.jC)("Accordion", props);
  const ownProps = (0,styled_system_dist_index_esm/* omitThemingProps */.Lr)(props);
  const { htmlProps, descendants, ...context } = useAccordion(ownProps);
  const ctx = (0,react.useMemo)(() => ({ ...context, reduceMotion: !!reduceMotion }), [context, reduceMotion]);
  return /* @__PURE__ */ react.createElement(AccordionDescendantsProvider, {
    value: descendants
  }, /* @__PURE__ */ react.createElement(AccordionProvider, {
    value: ctx
  }, /* @__PURE__ */ react.createElement(AccordionStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    ref,
    ...htmlProps,
    className: cx("chakra-accordion", props.className),
    __css: styles.root
  }, children))));
});
Accordion.displayName = "Accordion";

// src/use-accordion-item-state.ts
function useAccordionItemState() {
  const { isOpen, isDisabled, onClose, onOpen } = useAccordionItemContext();
  return { isOpen, onClose, isDisabled, onOpen };
}



/***/ }),

/***/ 98053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useControllableState; }
/* harmony export */ });
/* unused harmony export useControllableProp */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19251);
// src/index.ts


function useControllableProp(prop, state) {
  const controlled = typeof prop !== "undefined";
  const value = controlled ? prop : state;
  return useMemo(() => [controlled, value], [controlled, value]);
}
function useControllableState(props) {
  const {
    value: valueProp,
    defaultValue,
    onChange,
    shouldUpdate = (prev, next) => prev !== next
  } = props;
  const onChangeProp = (0,_chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(onChange);
  const shouldUpdateProp = (0,_chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(shouldUpdate);
  const [uncontrolledState, setUncontrolledState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue);
  const controlled = valueProp !== void 0;
  const value = controlled ? valueProp : uncontrolledState;
  const setValue = (0,_chakra_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)((next) => {
    const setter = next;
    const nextValue = typeof next === "function" ? setter(value) : next;
    if (!shouldUpdateProp(value, nextValue)) {
      return;
    }
    if (!controlled) {
      setUncontrolledState(nextValue);
    }
    onChangeProp(nextValue);
  }, [controlled, onChangeProp, value, shouldUpdateProp]);
  return [value, setValue];
}



/***/ }),

/***/ 57580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/uikit/Buttons/SocialButton.tsx



const SocialButton = _ref => {
  let {
    icon,
    label,
    href
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* IconButton */.hU, {
    mx: "1",
    bg: "primaryGreen.300",
    "aria-label": label,
    isRound: true,
    as: "a",
    href: href,
    title: `Visita il profilo ${label} di CarPlanner`,
    target: "_blank",
    icon: icon,
    transition: "background 0.3s ease",
    _hover: {
      bg: 'primaryGreen.800'
    }
  });
};

/* harmony default export */ var Buttons_SocialButton = (SocialButton);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
;// CONCATENATED MODULE: ./src/components/Footer/Column.tsx





const Title = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
    as: "h6",
    fontFamily: "Montserrat-SemiBold",
    textTransform: "uppercase",
    fontSize: "0.875rem",
    lineHeight: "18px",
    letterSpacing: ".2px",
    color: "baseDark",
    mb: 2,
    children: children
  });
};

const FooterColumn = _ref2 => {
  let {
    title,
    items
  } = _ref2;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Stack */.Kq, {
    align: "flex-start",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: title
    }), items && items.map(child => /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
      title: child.title,
      target: child.target,
      fontFamily: "Montserrat-Medium",
      fontSize: "0.875rem",
      lineHeight: "18px",
      letterSpacing: ".2px",
      color: "baseNeutral.700",
      href: child.href,
      children: child.name
    }, child.name))]
  });
};

/* harmony default export */ var Column = (FooterColumn);
;// CONCATENATED MODULE: ./src/components/Footer/Desktop.tsx








const LogoImg = /*#__PURE__*/styled_components_browser_esm["default"].img.withConfig({
  componentId: "sc-199nxhz-0"
})(["margin:50px auto auto;width:5rem;"]);

const FooterDesktop = _ref => {
  let {
    display,
    titleCol1,
    col1,
    titleCol2,
    col2,
    titleCol3,
    col3,
    copyright
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
    display: display,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Container */.W2, {
      as: layout_dist_index_esm/* Stack */.Kq,
      maxW: "6xl",
      py: 10,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* SimpleGrid */.MI, {
        templateColumns: "1.4fr 1.4fr 0.8fr 0.8fr",
        spacing: 8,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Column, {
          title: titleCol1,
          items: col1
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Column, {
          title: titleCol2,
          items: col2
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Column, {
          title: titleCol3,
          items: col3
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* SimpleGrid */.MI, {
            templateColumns: "repeat(4, 1fr)",
            spacing: "0.2rem",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_SocialButton, {
              label: "Facebook",
              href: "https://www.facebook.com/carplannercom",
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaFacebook */.Am9, {
                color: "#1b4832"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_SocialButton, {
              label: "Instagram",
              href: "https://www.instagram.com/carplanner_ita/",
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaInstagram */.Zf_, {
                color: "#1b4832"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_SocialButton, {
              label: "Linkedin",
              href: "https://www.linkedin.com/company/carplanner/",
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaLinkedin */.ltd, {
                color: "#1b4832"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_SocialButton, {
              label: "Twitter",
              href: "https://twitter.com/CarPlannerIT",
              icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
                color: "#1b4832"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "https://pledge1percent.org/",
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoImg, {
              src: "https://static1.carplanner.com/logos/Pledge1_ProudMember_Large.png",
              alt: "Pledge 1% member",
              loading: "lazy",
              decoding: "async",
              width: "89px",
              height: "80px"
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
      pb: 10,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Medium",
        fontSize: "0.625rem",
        color: "baseNeutral.700",
        textAlign: "center",
        children: copyright
      })
    })]
  });
};

/* harmony default export */ var Desktop = (FooterDesktop);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js + 1 modules
var accordion_dist_index_esm = __webpack_require__(27190);
;// CONCATENATED MODULE: ./src/components/Footer/MobileMenuItem.tsx





const MobileMenuItem = _ref => {
  let {
    title,
    items
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
    border: "0",
    borderBottom: "1px solid #dadde1",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
        p: "m",
        _hover: {
          background: 'none'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
          flex: "1",
          textAlign: "left",
          fontSize: "1rem",
          fontFamily: "Montserrat-SemiBold",
          textTransform: "uppercase",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {})]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
      pb: 4,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Stack */.Kq, {
        align: "flex-start",
        children: items && items.map(child => /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
          title: child.title,
          target: child.target,
          fontFamily: "Montserrat-Medium",
          fontSize: "0.875rem",
          lineHeight: "18px",
          letterSpacing: ".2px",
          color: "baseNeutral.700",
          href: child.href,
          children: child.name
        }, child.name))
      })
    })]
  });
};

/* harmony default export */ var Footer_MobileMenuItem = (MobileMenuItem);
;// CONCATENATED MODULE: ./src/components/Footer/Mobile.tsx








const Mobile_LogoImg = /*#__PURE__*/styled_components_browser_esm["default"].img.withConfig({
  componentId: "sc-c9gfy7-0"
})(["margin:20px auto auto;width:5rem;"]);

const FooterMobile = _ref => {
  let {
    display,
    titleCol1,
    col1,
    titleCol2,
    col2,
    titleCol3,
    col3,
    copyright
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
    mb: "9rem",
    display: display,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(accordion_dist_index_esm/* Accordion */.UQ, {
      allowToggle: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Footer_MobileMenuItem, {
        title: titleCol1,
        items: col1
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_MobileMenuItem, {
        title: titleCol2,
        items: col2
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer_MobileMenuItem, {
        title: titleCol3,
        items: col3
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
      p: "6",
      textAlign: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_SocialButton, {
        label: "Facebook",
        href: "https://www.facebook.com/carplannercom",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaFacebook */.Am9, {
          color: "#1b4832"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_SocialButton, {
        label: "Instagram",
        href: "https://www.instagram.com/carplanner_ita/",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaInstagram */.Zf_, {
          color: "#1b4832"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_SocialButton, {
        label: "Linkedin",
        href: "https://www.linkedin.com/company/carplanner/",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaLinkedin */.ltd, {
          color: "#1b4832"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons_SocialButton, {
        label: "Twitter",
        href: "https://twitter.com/CarPlannerIT",
        icon: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
          color: "#1b4832"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://pledge1percent.org/",
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Mobile_LogoImg, {
            src: "https://static1.carplanner.com/logos/Pledge1_ProudMember_Large.png",
            alt: "Pledge 1% member",
            loading: "lazy",
            decoding: "async",
            width: "89px",
            height: "80px"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
      px: "1rem",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
        fontFamily: "Montserrat-Medium",
        fontSize: "0.625rem",
        color: "baseNeutral.700",
        textAlign: "center",
        children: copyright
      })
    })]
  });
};

/* harmony default export */ var Mobile = (FooterMobile);
;// CONCATENATED MODULE: ./src/components/Footer/index.tsx








const Footer = _ref => {
  let {
    col1,
    col2,
    col3
  } = _ref;
  const {
    t
  } = (0,useTranslation/* useTranslation */.$)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Mobile, {
      display: {
        base: 'block',
        md: 'none'
      },
      titleCol1: t('common:footerMobile.titleCol1'),
      col1: col1,
      titleCol2: t('common:footerMobile.titleCol2'),
      col2: col2,
      titleCol3: t('common:footerMobile.titleCol3'),
      col3: col3,
      copyright: t('common:footerMobile.copyright')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Desktop, {
      display: {
        base: 'none',
        md: 'block'
      },
      titleCol1: t('common:footer.titleCol1'),
      col1: col1,
      titleCol2: t('common:footer.titleCol2'),
      col2: col2,
      titleCol3: t('common:footer.titleCol3'),
      col3: col3,
      copyright: t('common:footerMobile.copyright')
    })]
  });
};

/* harmony default export */ var components_Footer = (Footer);

/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ })

}]);